import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { ADMIN_MANY_ORDERS_API_PATHS } from '../constants/orders-api-paths.constant';
import HttpClient from '../../shared/infrastructures/clients/http.client';

export interface LabelProduct {
  title: string;
  size: number;
  quantity: number;
  uuid: string;
  productId?: string;
  name: string;
  ref: string;
  type: string;
}

export interface LabelBag {
  ownerFullname: string;
  deliveryDate: string;
  schedule: string;
  city: string;
  zip: string;
  title?: string;
  products: LabelProduct[];
  totalSize?: number;
}

export interface LabelsData {
  products: LabelBag[];
  baskets: LabelBag[];
}

interface LabelsState {
  loading: boolean;
  labels: LabelsData | null;
}

export function useGetLabelsByDate() {
  const { enqueueSnackbar } = useSnackbar();

  const [result, setResult] = useState<LabelsState>({
    loading: false,
    labels: null,
  });

  const fetchLabels = useCallback(
    (deliveryDate: string, ownerRole?: string): Promise<LabelsData | null> => {
      setResult({ loading: true, labels: null });

      const url = ADMIN_MANY_ORDERS_API_PATHS.GET_LABELS_BY_DATE.replace(':deliveryDate', deliveryDate);

      return HttpClient.get<LabelsData>(url, {
        params: { ownerRole: ownerRole !== 'all' ? ownerRole : undefined },
      })
        .then((response) => {
          setResult({ loading: false, labels: response });
          return response;
        })
        .catch((error) => {
          const message =
            error.response?.data?.message ?? 'Une erreur est survenue lors de la récupération des étiquettes';
          enqueueSnackbar(message, { variant: 'error' });
          setResult({ loading: false, labels: null });
          return null;
        });
    },
    [],
  );

  return { ...result, fetchLabels };
}
